import type { DropdownValue, FlatItem } from '../../types';

export function isFullySelected(
  item: FlatItem,
  descendantsByValue: Map<DropdownValue, DropdownValue[]>,
  selectedSet: Set<DropdownValue>,
): boolean {
  if (item.type === 'value') {
    return selectedSet.has(item.value);
  }

  const descendants = descendantsByValue.get(item.value) ?? [];

  return descendants.length > 0 && descendants.every((value) => selectedSet.has(value));
}
